import { Constants } from './samples-constants';
import { setGTMdataLayerEvents } from '../../utils/helpers';
import { addToCart, appendDiscountProperties } from '../../utils/add-to-cart';
import { showCartSideDraw } from '../../sections/cart-drawer';
import { updateCartWarning } from '../../templates/cart';
import { toggleElement } from '../../utils/toggle-element';

export const getItems = () => {
  const CartJS = window.CartJS || {};
  const cart = CartJS.cart;
  const items = (cart && cart.items) || [];
  return items.filter((item) => (item.properties || {})['_sample'] === 'true');
};

export const getNonSampleItems = () => {
  const CartJS = window.CartJS || {};
  const cart = CartJS.cart;
  const items = (cart && cart.items) || [];
  return items.filter((item) => (item.properties || {})['_sample'] !== 'true');
}

export const getSampleCount = () => {
  return getItems()
    .map((item) => {
      const properties = item.properties || {};
      if (properties['_kit'] === 'true') {
        return Number(properties['_kit_weight'] || 3);
      }
      return Number(item.quantity);
    })
    .reduce((a, b) => a + b, 0);
};

export const getProductCount = () => {
  const CartJS = window.CartJS || {};
  const cart = CartJS.cart;
  const items = (cart && cart.items) || [];
  return items.filter((item) => (item.properties || {})['_sample'] !== 'true')
    .map((item) => item.quantity)
    .reduce((a, b) => a + b, 0);
};

export const isProductInSamplesArray = (variantId) => {
  if (!variantId) return false;
  return getItems().some((item) => `${item.variant_id}` === `${variantId}`);
};

export const isCustomerLogin = () => {
  return document.querySelector('[name="customer-login"]')?.value === 'true';
};

export const hasReachedLimit = (newProductWeight = 0) => {
  const historyTotal = document.querySelector('[name="history-sample"]')?.value || 0;
  const total = getSampleCount() + Number(historyTotal) + Number(newProductWeight);
  const limit = Constants.els.sampleProductLimit;
  // if there is new item to add, it is fine to equal the limit
  // otherwise it is already hitting the limit
  return newProductWeight ? total > limit : total >= limit;
};

export const equalOrBeBelowLimit = () => {
  const historyTotal = document.querySelector('[name="history-sample"]')?.value || 0;
  const total = getSampleCount() + Number(historyTotal);
  const limit = Constants.els.sampleProductLimit;
  return total <= limit;
};

export const noSample = () => {
  return getSampleCount() === 0;
};

export const updateSampleButtonText = (text, isDisabled = false) => {
  const buttonContainer = document.querySelector('#product-hero__sample-badge');
  if (buttonContainer) {
    const button = buttonContainer.querySelector('button');
    if (button) {
      button.innerHTML = `${text}`;
      if (isDisabled) {
        button.classList.add('cta-button--disabled');
        button.setAttribute('disabled', true);
        button.classList.remove('sample');
      } else {
        button.classList.remove('cta-button--disabled');
        button.classList.remove('cta-button--grey');
        button.removeAttribute('disabled');
        button.classList.add('sample');
      }
    }
  }
}

export const updateCheckoutButton = () => {
  const checkoutBtn = document.querySelector('[name="checkout"]');
  if (!checkoutBtn) return; // Button might not exist for guest users

  const isLoggedIn = isCustomerLogin();
  const sampleCount = getSampleCount();
  const hasSamples = sampleCount > 0;

  // Check if quota has been exceeded
  const history = Number(document.querySelector('[name="history-sample"]')?.value || 0);
  const { sampleProductLimit } = Constants.els;
  const quota = sampleProductLimit - sampleCount - history;
  const quotaExceeded = quota < 0;


  if (isLoggedIn) {
    if (hasSamples && quotaExceeded) {
      // User is logged in but quota exceeded - disable checkout button
      checkoutBtn.classList.add('disabled');
      checkoutBtn.disabled = true;
    } else {
      // User is logged in and quota not exceeded - enable checkout button
      checkoutBtn.classList.remove('disabled');
      checkoutBtn.classList.add('cta-button--blue');
      checkoutBtn.disabled = false;
    }
  } else if (hasSamples) {
    // console.log('disabling checkout for guest');
    checkoutBtn.classList.add('disabled');
    checkoutBtn.disabled = true;
  } else {
    checkoutBtn.classList.remove('disabled');
    checkoutBtn.classList.add('cta-button--blue');
    checkoutBtn.disabled = false;
  }
}

export const updateActionButtons = () => {
  const continueToCheckoutBtn = document.querySelector('.cart-drawer__content__form-actions--checkout');
  const continueToLoginBtn = document.querySelector('.cart-drawer__content__form-actions--login');
  
  // If buttons don't exist (not in cart drawer), return early
  if (!continueToCheckoutBtn && !continueToLoginBtn) return;
  
  const isLoggedIn = isCustomerLogin();
  const sampleCount = getSampleCount();
  const hasSamples = sampleCount > 0;
  const history = Number(document.querySelector('[name="history-sample"]')?.value || 0);
  const { sampleProductLimit } = Constants.els;
  const quota = sampleProductLimit - sampleCount - history;
  const quotaExceeded = quota < 0;

  if (isLoggedIn || !hasSamples) {
    // Show checkout button, hide login button
    toggleElement(continueToCheckoutBtn, true);
    toggleElement(continueToLoginBtn, false);

    // Additionally check quota for checkout button state
    if (continueToCheckoutBtn) {
      if (hasSamples && quotaExceeded) {
        continueToCheckoutBtn.classList.add('disabled');
        continueToCheckoutBtn.disabled = true;
      } else {
        continueToCheckoutBtn.classList.remove('disabled');
        continueToCheckoutBtn.disabled = false;
      }
    }
  } else {
    // Show login button, hide checkout button
    toggleElement(continueToCheckoutBtn, false);
    toggleElement(continueToLoginBtn, true);
  }
}

export const getSampleButtonText = (variantId, sampleKit = false, sampleKitWeight = 3, variantIds = []) => {
  let variantIdsArray = [];
  if (typeof variantIds === 'string') {
    variantIdsArray = variantIds.split(',');
  } else {
    variantIdsArray = variantIds;
  }
  // const button = document.querySelector('#product-hero__sample-badge') || document.querySelector('.add-to-samples-cta');
  const isKit = [true, "true"].includes(sampleKit);
  const { limitReachedButtonText, requestSampleButtonText, requestSampleKitButtonText, addedToSamplesButtonText } = Constants.els
  if (variantIdsArray.length && variantIdsArray.every((id) => isProductInSamplesArray(id))) {
    return addedToSamplesButtonText;
  }
  if (!variantIds.length && isProductInSamplesArray(variantId)) {
    return addedToSamplesButtonText;
  } else if (hasReachedLimit(isKit ? Number(sampleKitWeight) : 1)) {
    return limitReachedButtonText;
  } else {
    return isKit ? requestSampleKitButtonText : requestSampleButtonText;
  }
}

export const shouldDisabledSampleButton = (text) => {
  return ![Constants.els.requestSampleButtonText, Constants.els.requestSampleKitButtonText].includes(text);
}

export const checkSampleThresholdReached = (variantId, sampleKit = false, sampleKitWeight = 3) => {
  const text = getSampleButtonText(variantId, sampleKit, sampleKitWeight);
  updateSampleButtonText(text, shouldDisabledSampleButton(text));
}

export const updateCartCounter = (cart = window.CartJS?.cart) => {
  const sampleCount = getSampleCount();
  // console.log('updating cart counter', sampleCount);
  $(document)
    .find('.new-layout-header__actions-cart-counter')
    .text(getProductCount());
  $(document)
    .find('.new-layout-header__actions-cart-counter-sample')
    .text(sampleCount);
  const history = Number(document.querySelector('[name="history-sample"]')?.value || 0);
  const quotaInput = document.querySelector('[name="quota-left"]');
  const cartSampleWarningContainers = document.querySelectorAll('.cart-sample-warning');
  const loginMsg = document.querySelectorAll('.request_login_signup');
  const remainingParagraphs = document.querySelectorAll('.cart-sample-warning .remaining');
  const { sampleProductLimit } = Constants.els;
  const newQuota = sampleProductLimit - sampleCount - history;
  const newQuotaLeft = Math.max(newQuota, 0);
  const newQuotaExceeded = Math.abs(newQuota);
  if (quotaInput) {
    quotaInput.value = newQuotaLeft;
  }

  // Update remaining paragraph text based on quota status for all instances
  remainingParagraphs.forEach((remainingParagraph) => {
    if (newQuota > 0) {
      const sampleWord = newQuota === 1 ? 'sample' : 'samples';
      remainingParagraph.innerHTML = `You can add <strong>${newQuota}</strong> more ${sampleWord} to your cart`;
    } else if (newQuota === 0) {
      remainingParagraph.innerHTML = 'You cannot add any more samples to your cart.';
    } else {
      const removeSampleWord = newQuotaExceeded === 1 ? 'sample' : 'samples';
      remainingParagraph.innerHTML = `Please remove <strong>${newQuotaExceeded}</strong> ${removeSampleWord} to proceed to checkout`;
    }
  });

  if (sampleCount > 0) {
    loginMsg?.forEach((msg) => msg.classList.remove('hide'));
    cartSampleWarningContainers?.forEach((warning) => warning.classList.remove('hide'));
  } else {
    loginMsg?.forEach((msg) => msg.classList.add('hide'));
    cartSampleWarningContainers?.forEach((warning) => warning.classList.add('hide'));
  }

  if (newQuota < 0) {
    cartSampleWarningContainers?.forEach((warning) => warning.classList.add('red'));
  } else {
    cartSampleWarningContainers?.forEach((warning) => warning.classList.remove('red'));
  }

  // Update checkout button state based on quota
  updateCheckoutButton();
  updateActionButtons();
};

export const updateAllSampleButtons = () => {
  // Update collection page buttons
  updateAllCollectionSampleButtonsText();
  
  // Update PDP sample button if on product page
  const dataset = document.querySelector('[data-product-form]')?.dataset;
  if (dataset && dataset.sampleVariantId) {
    const isKit = ['true', true].includes(dataset.sampleKit);
    const text = getSampleButtonText(dataset.sampleVariantId, isKit, isKit ? dataset.sampleKitWeight : 1);
    updateSampleButtonText(text, shouldDisabledSampleButton(text));
  }
  // TODO: any other locations with sample buttons to update? clarify with team for the slider sections and update accordingly if not already covered
};

export const updateAllCollectionSampleButtonsText = () => {
  const cards = document.querySelectorAll('.prod-card') || [];
  cards.forEach((card) => {
    const variantId = card.dataset.sampleVariantId || card.dataset.productVariantId;
    const variantIds = (card.dataset.sampleVariantIds || '').split(',');
    const isKit = ['true', true].includes(card.dataset.sampleKit) || ['true', true].includes(card.dataset.productKit);
    const weight = card.dataset.sampleKitWeight || card.dataset.productKitWeight;
    const text = getSampleButtonText(variantId, isKit, isKit ? weight : 1, variantIds);
    const isDisabled = shouldDisabledSampleButton(text);
    updateSingleSampleButtonText(card, text, isDisabled);
    // tick it as long as any of the variantIds are in the samples array
    const sampleSelected = card.querySelector('.prod-card__sample-selected');
    if (sampleSelected) {
      if (variantIds.length && variantIds.some((id) => isProductInSamplesArray(id))) {
        sampleSelected.classList.add('selected');
      } else {
        sampleSelected.classList.remove('selected');
      }
    }
  });
};

export const updateSingleSampleButtonText = (element, text, isDisabled = false) => {
  const buttons = element.querySelectorAll('.add-to-samples-cta');

  buttons.forEach((button) => {
    button.firstChild.innerHTML = text;
    if (isDisabled) {
      button.classList.remove('cta-button--green');
      button.classList.add('cta-button--disabled');
    } else {
      button.classList.remove('cta-button--disabled');
      button.classList.add('cta-button--green');
    }
  });
};

export const addSamples = async (samples, location, pFCustomerType = {}) =>
  new Promise(async (resolve, reject) => {
    const sampleToAdd = samples
      .filter((sample) => sample.handle && sample.variant_id && !isProductInSamplesArray(sample.variant_id))
      .map((sample) => ({
        quantity: 1,
        handle: sample.handle,
        id: sample.variant_id,
        ...(sample.isSample ? {
          properties: {
            _sample: 'true',
            _kit: sample.isKit,
            _added_from: location,
            ...(sample.isKit ? { _kit_weight: sample.weight } : {}),
            ...(pFCustomerType ? { _customer_type: `${pFCustomerType.type} ${pFCustomerType.gender}` } : {}),
          }
        } : {}),
      }));

    if (sampleToAdd.length === 0) {
      return resolve(false);
    }

    await Promise.allSettled(sampleToAdd.map(async (sample) => {
      const a = await appendDiscountProperties(sample.productHandle, sample.lineItemProperties);
      return a;
    }));

    const CartJS = window.CartJS || {};

    const cartJsOptions = {
      success: function (data, textStatus, jqXHR) {
        document.dispatchEvent(
          new CustomEvent("cartjs:addItem", {
            detail: { successData: data },
          })
        );
        resolve();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('addToCart() Error: ' + errorThrown + '!');
        reject();
      },
    };

    CartJS.addItems(sampleToAdd, cartJsOptions);
  });

/**
 * for this function - we do not restrict people to add samples
 * samples quota validation should be done at button level
 * guest can add 3 samples maximum as well until they checkout which will require them to login
 * we will validate the quota at the checkout or cart after they login
 */
export const addSample = (sampleVariantId, sampleHandle, location = Constants.locations.PDP, kit = false, weight = 3) =>
  new Promise((resolve, reject) => {
    if (!sampleHandle || !sampleVariantId) {
      return resolve(false);
    }

    if (isProductInSamplesArray(sampleVariantId)) return resolve(false);
    const isKit = ['true', true].includes(kit);
    setGTMdataLayerEvents('sample-add', [sampleHandle], location);
    addToCart({
      quantity: 1,
      productHandle: sampleHandle,
      selectedVariantID: sampleVariantId,
      lineItemProperties: {
        _sample: 'true',
        _kit: isKit,
        _added_from: location,
        ...(isKit ? { _kit_weight: weight } : {}),
      },
    });

    resolve();
  });

export const addEventListeners = () => {
  $(document).on('cart.requestComplete', function (event, cart) {
    updateCartCounter(cart);
    updateCheckoutButton();
    updateCartWarning();
    
    // Update all sample button states after cart changes
    updateAllSampleButtons();

    // Only show the cart side draw if the product is not the product finder
    const body = event.currentTarget.body;
    if (
      !body.classList.contains("template-page-product-finder-2024") &&
      !body.classList.contains("template-cart")
    ) {
      showCartSideDraw();
    }
  });
}

/**
 * This Class is to help create a single location for methods
 * in order to use the functionality of this feature without
 * having to repeat/double up the logic across the build
 */
class ProductSamplesClass {
  constructor(vueInstance) {
    this.vm = vueInstance;
  }
  // **************
  // Static Methods => Means we can access method without Class being instantiated
  // Docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes
  // **************

  // *******************
  // Collection Template
  // We are using a different set of methods here
  // becuase the collection templates are using a
  // shopify app called boost search and filter.
  // *******************
  addCollectionProductToSamples = (event, handle, variantId, isKit = false, weight = 3) => {
    // Add Sample To Basket
    this.addToProductSamples(variantId, handle, Constants.locations.Collection, isKit, weight);

    // // Update Button Styles
    // event.currentTarget.classList.remove('cta-button--green');
    // event.currentTarget.classList.add('cta-button--disabled');
  };
  checkForSampleLimit = function () {
    // Here we want to check if the limit has been reached...

    const sampleProducts = getItems().map((item) => ({ handle: item.handle, variantId: item.variant_id }));
    // Even if limit reached, we want to update the Selected/Added Sample Products
    sampleProducts.forEach(({ handle, variantId }) => {
      const element = document.querySelector(
        `[data-sample-handle="${handle}"]`
      );
      if (element && isProductInSamplesArray(variantId)) {
        updateSingleSampleButtonText(
          element,
          Constants.els.addedToSamplesButtonText,
          true
        );
      }
    });
  };
  // END Collection Template
  // ***********************

  // *******************
  // Vue Component Methods
  // *******************
  addToProductSamples = (id, handle, location = '', isKit = false, weight = 3) => {
    const { addedToSamplesButtonText } = Constants.els;
    // we only add to samples if the limit has not been reached
    // and the customer has not logged in
    // by default  history sample is 0
    // so the overall quota limit for non-logged in users is 3 as well

    if (!hasReachedLimit(isKit ? weight : 1)) {
      addSample(id, handle, location, isKit, weight).then(() => {
        this.updateSampleButtonText(addedToSamplesButtonText, true);
        updateAllSampleButtons();
      });
    } else {
      this.vm.disabledSampleButton = true;
      console.warn('Product Samples: Maximum limit reached');
    }
  };
  updateSampleButtonText = (text, isDisabled = false) => {
    this.vm.buttonText = text;
    isDisabled
      ? (this.vm.disabledSampleButton = true)
      : (this.vm.disabledSampleButton = false);
  };
  checkProductSampleAvailablity = (tags = []) => {
    if (!Array.isArray(tags)) {
      throw new Error(
        '[Method checkProductSampleAvailablity()]: tags is not an array'
      );
    }
    /**
     * It checks whether or not a product is available for
     * sampling, by looking through the product tags for a tag called:
     * 'disable_product_samples'
     */
    const hideSampingCTA = tags.find(
      (tag) => tag === 'disable_product_samples'
    );
    return hideSampingCTA ? true : false;
  };
}

export default ProductSamplesClass;
